/* Import Libs */

import oc from 'octobercms';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';

window.Alpine = Alpine

Alpine.plugin(focus);
Alpine.start()

import 'intersection-observer';
import './js/validation';
import './js/utils';
import './js/lazy-load';
import './js/global';
import './node_modules/focus-visible/dist/focus-visible';

/* * Header * */
import './partials/header/header'

/* * Drawer * */
//import './partials/header/drawer-nav/drawer-nav';

/* * Form * */

import './partials/form/input/input';

/* * Other * */

import './partials/common/wysiwyg/wysiwyg';

import './partials/common/callback/callback';